<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
  @import "style/commonStyle.less";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  margin-top: 60px;
  input::-webkit-input-placeholder{
    color:#BBBEC4;
  }
  input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#BBBEC4;
  }
  input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#BBBEC4;
  }
  input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:#BBBEC4;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue